var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0387 96.2313L153.145 83.8571C155.872 83.611 158.289 85.6037 158.568 88.3274L168.703 187.263C168.985 190.016 166.978 192.474 164.224 192.748L57.19 203.401L30.3303 217.897C27.1936 219.59 23.3436 217.551 22.9815 214.005L11.514 101.719C11.2311 98.9491 13.2655 96.4816 16.0387 96.2313Z",
    fill: "#F3E6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0387 93.0443L153.145 80.6701C155.872 80.424 158.289 82.4167 158.568 85.1403L168.703 184.076C168.985 186.829 166.978 189.287 164.224 189.561L57.19 200.214L30.3303 214.71C27.1936 216.403 23.3436 214.363 22.9815 210.818L11.514 98.5321C11.2311 95.7621 13.2655 93.2946 16.0387 93.0443Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.8761,
    y: 133.643,
    width: 94.9656,
    height: 10.0184,
    rx: 5.0092,
    transform: "rotate(-6.41524 37.8761 133.643)",
    fill: "#F3E6FB",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.9376,
    y: 149.275,
    width: 68.3001,
    height: 10.0184,
    rx: 5.0092,
    transform: "rotate(-6.41524 73.9376 149.275)",
    fill: "#F3E6FB",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.337 44.9582L266.188 65.201C268.71 65.5943 270.531 67.8246 270.412 70.3747L265.723 170.717C265.542 174.593 261.207 176.794 257.971 174.654L232.395 157.741L128.196 143.001C125.586 142.632 123.711 140.301 123.91 137.673L130.581 49.5212C130.801 46.6123 133.455 44.5088 136.337 44.9582Z",
    fill: "#DFF9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.991 42.8341L268.842 63.077C271.364 63.4702 273.185 65.7006 273.066 68.2507L268.377 168.593C268.196 172.469 263.861 174.67 260.625 172.53L235.05 155.617L130.85 140.877C128.241 140.508 126.366 138.177 126.564 135.549L133.235 47.3972C133.456 44.4883 136.109 42.3848 138.991 42.8341Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0016,
    y: 153.235,
    width: 28.4901,
    height: 10.0184,
    rx: 5.0092,
    transform: "rotate(-6.41524 41.0016 153.235)",
    fill: "#F3E6FB",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.918,
    y: 77.3821,
    width: 94.9656,
    height: 10.0184,
    rx: 5.0092,
    transform: "rotate(8.5647 152.918 77.3821)",
    fill: "#DFF9FE",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.709,
    y: 101.805,
    width: 68.3001,
    height: 10.0184,
    rx: 5.0092,
    transform: "rotate(8.5647 183.709 101.805)",
    fill: "#DFF9FE",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.871,
    y: 97.1153,
    width: 28.4901,
    height: 10.0184,
    rx: 5.0092,
    transform: "rotate(8.5647 150.871 97.1153)",
    fill: "#DFF9FE",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.572,
    cy: 246.935,
    rx: 102.468,
    ry: 11.6802,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 11.0906,
    y2: -0.3,
    transform: "matrix(0.548838 -0.83822 -0.835296 -0.546297 278.349 51.5806)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 6.81618,
    y2: -0.3,
    transform: "matrix(-0.979704 0.204356 -0.204462 -0.978049 288.68 57.2207)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 6.3692,
    y2: -0.3,
    transform: "matrix(0.12903 0.99113 -0.992067 0.129563 271.161 43.728)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportPortal);
export default __webpack_public_path__ + "static/media/support-portal.39cd78736656eb38c35b37e1d0936c0d.svg";
export { ForwardRef as ReactComponent };